// CLABE helpers.
//
// The first three digits of a CLABE ARE the bank code, so the institution never
// needs to be asked for — it is already in the number. That removes a whole
// class of error: a hand-picked dropdown drifting from the account it labels.
// (One provider had "AFIRME" recorded against a 072/Banorte CLABE.)
//
// The authoritative name is whatever Fintoc returns on verification; this table
// is for instant feedback in the form before that round trip happens.
export const CLABE_BANKS = {
  "002": "BANAMEX",
  "006": "BANCOMEXT",
  "009": "BANOBRAS",
  "012": "BBVA MEXICO",
  "014": "SANTANDER",
  "019": "BANJERCITO",
  "021": "HSBC",
  "030": "BAJIO",
  "036": "INBURSA",
  "042": "MIFEL",
  "044": "SCOTIABANK",
  "058": "BANREGIO",
  "059": "INVEX",
  "060": "BANSI",
  "062": "AFIRME",
  "072": "BANORTE",
  "103": "AMERICAN EXPRESS",
  "106": "BANK OF AMERICA",
  "110": "JP MORGAN",
  "112": "BMONEX",
  "113": "VE POR MAS",
  "116": "ING",
  "124": "DEUTSCHE",
  "127": "AZTECA",
  "128": "AUTOFIN",
  "129": "BARCLAYS",
  "130": "COMPARTAMOS",
  "132": "MULTIVA BANCO",
  "133": "ACTINVER",
  "135": "NAFIN",
  "136": "INTERCAM BANCO",
  "137": "BANCOPPEL",
  "138": "ABC CAPITAL",
  "140": "CONSUBANCO",
  "141": "VOLKSWAGEN",
  "143": "CIBANCO",
  "145": "BBASE",
  "147": "BANKAOOL",
  "148": "PAGATODO",
  "150": "INMOBILIARIO",
  "151": "DONDE",
  "152": "BANCREA",
  "154": "BANCO FINTERRA",
  "155": "ICBC",
  "156": "SABADELL",
  "157": "SHINHAN",
  "158": "MIZUHO",
  "160": "BANCO COVALTO",
  "166": "BANCO DEL BIENESTAR",
  "168": "HIPOTECARIA FEDERAL",
  "600": "MONEXCB",
  "601": "GBM",
  "605": "VALUE",
  "608": "VECTOR",
  "616": "FINAMEX",
  "617": "VALMEX",
  "620": "PROFUTURO",
  "630": "CB INTERCAM",
  "631": "CI BOLSA",
  "634": "FINCOMUN",
  "638": "NU MEXICO",
  "646": "STP",
  "652": "CREDICAPITAL",
  "653": "KUSPIT",
  "656": "UNAGRA",
  "670": "LIBERTAD",
  "677": "CAJA POPULAR MEXICANA",
  "684": "TRANSFER",
  "706": "ARCUS",
  "710": "NVIO",
  "722": "MERCADO PAGO",
};

export const clabeDigits = (v) => String(v ?? "").replace(/\D/g, "");

export function clabeBankName(clabe) {
  return CLABE_BANKS[clabeDigits(clabe).slice(0, 3)] || null;
}

// CLABE's 18th digit is a mod-10 check digit over the first 17, weighted
// 3,7,1 repeating. Validating locally turns a typo into instant feedback
// instead of a 78-second round trip and a wasted 0.01 MXN verification.
export function isValidClabe(clabe) {
  const d = clabeDigits(clabe);
  if (d.length !== 18) return false;
  const weights = [3, 7, 1];
  let sum = 0;
  for (let i = 0; i < 17; i += 1) {
    sum += ((Number(d[i]) * weights[i % 3]) % 10);
  }
  const expected = (10 - (sum % 10)) % 10;
  return expected === Number(d[17]);
}
